var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C0E0BEBF-CAA5-4B3C-B697-6A18FCF8A7F6@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Sign-In-Filled-Out",
    transform: "translate(-284.000000, -336.000000)",
    fill: "#2774AE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.605345,346.378276 C300.605345,346.742306 300.50295,347.079778 300.338919,347.376696 L295.095931,341.510543 L300.282075,336.973129 C300.483819,337.293285 300.605345,337.669361 300.605345,338.075758 L300.605345,346.378276 Z M292.302689,342.575663 L299.51904,336.261532 C299.222909,336.099418 298.889441,336 298.529724,336 L286.075655,336 C285.715493,336 285.381922,336.099418 285.086989,336.261532 L292.302689,342.575663 Z M294.314553,342.193667 L292.644166,343.65615 C292.546459,343.741262 292.424797,343.783767 292.302689,343.783767 C292.180514,343.783767 292.058851,343.741262 291.961145,343.65615 L290.290381,342.193598 L284.981069,348.134734 C285.299308,348.334391 285.67227,348.454 286.075621,348.454 L298.529724,348.454 C298.933007,348.454 299.306139,348.334391 299.624276,348.134734 L294.314553,342.193667 Z M284.323338,336.973095 C284.121628,337.293251 284,337.669326 284,338.075758 L284,346.378311 C284,346.74234 284.101916,347.079812 284.266562,347.37673 L289.508934,341.50955 L284.323338,336.973095 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailShape);
export default __webpack_public_path__ + "static/media/EmailShape.4244fce5bdaed33385e98a5fd9d1399f.svg";
export { ForwardRef as ReactComponent };